export default {
    user: {
        create: {
            title: "新用户",
            model: {
                email: {
                    label: "电子邮件",
                    placeholder: "填写邮箱"
                },
                name: {
                    label: "姓名",
                    placeholder: "填写姓名"
                },
                country: {
                    label: "国家",
                    placeholder: "填写国家"
                },
                approval_manager_email: {
                    label: "经理邮箱",
                    placeholder: "填写经理邮箱",
                    errors: {
                        different: "审批经理的电子邮件必须与用户的电子邮件不同"
                    }
                }
            },
            cta: {
                submit: {
                    text: "提交",
                    processing: "提交"
                },
                cancel: {
                    text: "取消"
                }
            }
        },
        country: {
            title: "用户所在国家",
            header: "{email} 尚未选择国家/地区。请选择其国家/地区。",
            model: {
                country: {
                    label: "国家",
                    placeholder: "填写国家"
                }
            },
            cta: {
                submit: {
                    text: "提交",
                    processing: "提交"
                },
                cancel: {
                    text: "取消"
                }
            }
        }
    }
}